/* eslint-disable */
/**
 * This file was generated by TypeScriptGen v0.0.2
 * Any changes to this file will be lost if regenerated 
 */
import Axios, {type AxiosResponse} from 'axios';
import {queryUrl, toFormData, defaultConfig, defaultFormConfig} from "./helper";
import type PaginationResponse from "./PaginationResponse";
import type TestType from "./TestType";
import type PaginationRequestSearch from "./PaginationRequestSearch";
import type IdRequest from "./IdRequest";
import type TestTypeUpsert from "./TestTypeUpsert";
import type TestTypePlacement from "./TestTypePlacement";
import type GroupRequest from "./GroupRequest";
import type IdsRequest from "./IdsRequest";

export default {
    pagedActive(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<TestType>>> {
        return Axios.post("/api/testtype/pagedactive", request, defaultConfig);
    },
    pagedArchived(request: PaginationRequestSearch): Promise<AxiosResponse<PaginationResponse<TestType>>> {
        return Axios.post("/api/testtype/pagedarchived", request, defaultConfig);
    },
    detail(request: IdRequest): Promise<AxiosResponse<TestType>> {
        return Axios.post("/api/testtype/detail", request, defaultConfig);
    },
    upsert(request: TestTypeUpsert): Promise<AxiosResponse> {
        return Axios.post("/api/testtype/upsert", request, defaultConfig);
    },
    archive(request: IdRequest): Promise<AxiosResponse> {
        return Axios.post("/api/testtype/archive", request, defaultConfig);
    },
    restore(request: IdRequest): Promise<AxiosResponse> {
        return Axios.post("/api/testtype/restore", request, defaultConfig);
    },
    group(request: GroupRequest): Promise<AxiosResponse<TestTypePlacement[]>> {
        return Axios.post("/api/testtype/group", request, defaultConfig);
    },
    reorder(request: IdsRequest): Promise<AxiosResponse> {
        return Axios.post("/api/testtype/reorder", request, defaultConfig);
    }
}
